import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import {
  PhonelinkSetup,
  DeviceHub,
  DevicesOther,
  BorderHorizontal,
  HdrWeak,
} from "@material-ui/icons";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";

import styles from "assets/jss/material-kit-react/views/componentsSections/pillsStyle.js";
import img1 from "assets/img/fc3.png";
import img2 from "assets/img/pcb.jpeg";
import img3 from "assets/img/pit.jpeg";
import img4 from "assets/img/tech.jpeg";
import img5 from "assets/img/ld.jpeg";

import CanvaVideo from "./CanvaVideo";

const useStyles = makeStyles(styles);

export default function SectionPills() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <div id="navigation-pills">
          <div className={classes.title}>
            <h3>
              <b>Product Description</b>
            </h3>
          </div>
          <div className={classes.title}>
            <h3>{/* <small>With Icons</small> */}</h3>
          </div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <NavPills
                color="info"
                horizontal={{
                  tabsGrid: { xs: 12, sm: 4, md: 4 },
                  contentGrid: { xs: 12, sm: 8, md: 8 },
                }}
                tabs={[
                  {
                    tabButton: "Technology",
                    tabIcon: DevicesOther,
                    tabContent: (
                      <span>
                        <img src={img4} className="img-fluid d-flex mx-auto"></img>
                        {/* <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          The major Technology used in our product is first
                          realtime Objection Detection which can be done through
                          various pretrained models available over internet
                          along with some proficient proximity sensors. Till now
                          as we have detected objects in real world in real time
                          and stimulated the legs of people to move them
                          avoiding obstacles. We did this by using Muscle
                          Stimulator, it’s used by various fitness trainees and
                          in medical sciences for stimulating muscles, for
                          contracting and relaxing them outside their body to
                          relax muscles, we are doing nothing new here, we will
                          use this technology to control the muscles and through
                          them control the movement of legs as per our model
                          avoiding obstacle and there are many efficient muscle
                          stimulator are available in the market which works
                          very precisely on the targeted nerves.
                        </p> */}
                        <br />
                        {/* <p>
                          Real-time Obstacle Detection and Avoidance. It will
                          simulate your movement as soon as it detects obstacle
                          in its avoidance range.
                        </p>
                        <br />
                        <p>
                          No involvement from the user like holding a cane or
                          positioning the mobile camera. Just take our device
                          and you get our Artificial Eyes.
                        </p> */}
                      </span>
                    ),
                  },
                  {
                    tabButton: "App + GPS",
                    tabIcon: PhonelinkSetup,
                    tabContent: (
                      <span>
                        <img src={img1} className="img-fluid d-flex mx-auto"></img>
                        {/* <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          He/She can also select a specific route for navigation
                          using an inbuilt chatbot which will be tracked using
                          GPS in real-time and help him reach his destination.
                        </p>
                        <br />
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          We are planning to integrate our product with Google
                          Maps to assist the user in reaching his destination by
                          providing directional assistance.
                        </p>
                        <br />
                        <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          Avoiding all the Obstacles and Giving user all the
                          information about his environment to make it more
                          interactive plus user friendly.
                        </p> */}
                      </span>
                    ),
                  },
                  {
                    tabButton: "PCB Design",
                    tabIcon: BorderHorizontal,
                    tabContent: (
                      <span>
                        <img src={img2} className="img-fluid d-flex mx-auto"></img>
                        {/* <img src={img1} className="img-fluid d-flex mx-auto"></img> */}
                        {/* <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          The major Technology used in our product is first
                          realtime Objection Detection which can be done through
                          various pretrained models available over internet
                          along with some proficient proximity sensors. Till now
                          as we have detected objects in real world in real time
                          and stimulated the legs of people to move them
                          avoiding obstacles. We did this by using Muscle
                          Stimulator, it’s used by various fitness trainees and
                          in medical sciences for stimulating muscles, for
                          contracting and relaxing them outside their body to
                          relax muscles, we are doing nothing new here, we will
                          use this technology to control the muscles and through
                          them control the movement of legs as per our model
                          avoiding obstacle and there are many efficient muscle
                          stimulator are available in the market which works
                          very precisely on the targeted nerves.
                        </p> */}
                        <br />
                        {/* <p>
                          Real-time Obstacle Detection and Avoidance. It will
                          simulate your movement as soon as it detects obstacle
                          in its avoidance range.
                        </p>
                        <br />
                        <p>
                          No involvement from the user like holding a cane or
                          positioning the mobile camera. Just take our device
                          and you get our Artificial Eyes.
                        </p> */}
                      </span>
                    ),
                  },
                  {
                    tabButton: "Pit Detection",
                    tabIcon: HdrWeak,
                    tabContent: (
                      <span>
                        <img src={img3} className="img-fluid d-flex mx-auto"></img>
                        {/* <img src={img1} className="img-fluid d-flex mx-auto"></img> */}
                        {/* <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          The major Technology used in our product is first
                          realtime Objection Detection which can be done through
                          various pretrained models available over internet
                          along with some proficient proximity sensors. Till now
                          as we have detected objects in real world in real time
                          and stimulated the legs of people to move them
                          avoiding obstacles. We did this by using Muscle
                          Stimulator, it’s used by various fitness trainees and
                          in medical sciences for stimulating muscles, for
                          contracting and relaxing them outside their body to
                          relax muscles, we are doing nothing new here, we will
                          use this technology to control the muscles and through
                          them control the movement of legs as per our model
                          avoiding obstacle and there are many efficient muscle
                          stimulator are available in the market which works
                          very precisely on the targeted nerves.
                        </p> */}
                        <br />
                        {/* <p>
                          Real-time Obstacle Detection and Avoidance. It will
                          simulate your movement as soon as it detects obstacle
                          in its avoidance range.
                        </p>
                        <br />
                        <p>
                          No involvement from the user like holding a cane or
                          positioning the mobile camera. Just take our device
                          and you get our Artificial Eyes.
                        </p> */}
                      </span>
                    ),
                  },
                  {
                    tabButton: "Logic Design",
                    tabIcon: DeviceHub,
                    tabContent: (
                      <span>
                        <img src={img5} className="img-fluid d-flex mx-auto"></img>
                        {/* <img src={img1} className="img-fluid d-flex mx-auto"></img> */}
                        {/* <p style={{ fontSize: "1.5rem", lineHeight: "2rem" }}>
                          The major Technology used in our product is first
                          realtime Objection Detection which can be done through
                          various pretrained models available over internet
                          along with some proficient proximity sensors. Till now
                          as we have detected objects in real world in real time
                          and stimulated the legs of people to move them
                          avoiding obstacles. We did this by using Muscle
                          Stimulator, it’s used by various fitness trainees and
                          in medical sciences for stimulating muscles, for
                          contracting and relaxing them outside their body to
                          relax muscles, we are doing nothing new here, we will
                          use this technology to control the muscles and through
                          them control the movement of legs as per our model
                          avoiding obstacle and there are many efficient muscle
                          stimulator are available in the market which works
                          very precisely on the targeted nerves.
                        </p> */}
                        <br />
                        {/* <p>
                          Real-time Obstacle Detection and Avoidance. It will
                          simulate your movement as soon as it detects obstacle
                          in its avoidance range.
                        </p>
                        <br />
                        <p>
                          No involvement from the user like holding a cane or
                          positioning the mobile camera. Just take our device
                          and you get our Artificial Eyes.
                        </p> */}
                      </span>
                    ),
                  },
                ]}
              />
            </GridItem>
            {/* <GridItem xs={12} sm={12} md={12} lg={12}>
              <NavPills
                color="primary"
                tabs={[
                  {
                    tabButton: "Dashboard",
                    tabIcon: BuildOutlined,
                    tabContent: (
                      <span>
                        <p>
                          Collaboratively administrate empowered markets via
                          plug-and-play networks. Dynamically procrastinate B2C
                          users after installed base benefits.
                        </p>
                        <br />
                        <p>
                          Dramatically visualize customer directed convergence
                          without revolutionary ROI. Collaboratively
                          administrate empowered markets via plug-and-play
                          networks. Dynamically procrastinate B2C users after
                          installed base benefits.
                        </p>
                        <br />
                        <p>
                          Dramatically visualize customer directed convergence
                          without revolutionary ROI. Collaboratively
                          administrate empowered markets via plug-and-play
                          networks. Dynamically procrastinate B2C users after
                          installed base benefits.
                        </p>
                      </span>
                    )
                  },
                  {
                    tabButton: "Schedule",
                    tabIcon: BuildOutlined,
                    tabContent: (
                      <span>
                        <p>
                          Efficiently unleash cross-media information without
                          cross-media value. Quickly maximize timely
                          deliverables for real-time schemas.
                        </p>
                        <br />
                        <p>
                          Dramatically maintain clicks-and-mortar solutions
                          without functional solutions. Dramatically visualize
                          customer directed convergence without revolutionary
                          ROI. Collaboratively administrate empowered markets
                          via plug-and-play networks. Dynamically procrastinate
                          B2C users after installed base benefits.
                        </p>
                      </span>
                    )
                  },
                  {
                    tabButton: "Tasks",
                    tabIcon: BuildOutlined,
                    tabContent: (
                      <span>
                        <p>
                          Collaboratively administrate empowered markets via
                          plug-and-play networks. Dynamically procrastinate B2C
                          users after installed base benefits.
                        </p>
                        <br />
                        <p>
                          Dramatically visualize customer directed convergence
                          without revolutionary ROI. Collaboratively
                          administrate empowered markets via plug-and-play
                          networks. Dynamically procrastinate B2C users after
                          installed base benefits.
                        </p>
                        <br />
                        <p>
                          Dramatically visualize customer directed convergence
                          without revolutionary ROI. Collaboratively
                          administrate empowered markets via plug-and-play
                          networks. Dynamically procrastinate B2C users after
                          installed base benefits.
                        </p>
                      </span>
                    )
                  }
                ]}
              />
            </GridItem> */}
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
